import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const StarBurst = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M82.0809 54.016L75.7785 56.8509L77.7168 63.4826L70.9085 64.6605L71.136 71.5668L64.248 71.0138L62.7514 77.7597L56.2176 75.5114L53.0899 81.6736L47.3203 77.8711L42.7594 83.0608L38.1168 77.9431L32.4077 81.8359L29.184 75.7245L22.6858 78.0756L21.0835 71.3536L14.2051 72.0151L14.3242 65.106L7.49759 64.0356L9.33119 57.3732L2.98559 54.6391L6.41759 48.642L0.951355 44.416L5.76767 39.4605L1.52447 34.0077L7.42079 30.4058L4.66751 24.0688L11.2742 22.0471L10.1827 15.2244L17.0851 14.9095L17.7254 8.02917L24.4896 9.44037L26.8195 2.93541L33.0202 5.98437L36.8957 0.263729L42.143 4.75941L47.3193 0.182129L51.2832 5.84133L57.4349 2.69445L59.8675 9.16197L66.6086 7.64421L67.3565 14.513L74.2637 14.7194L73.2797 21.5594L79.9181 23.4765L77.2637 29.8567L83.2166 33.3645L79.0598 38.8836L83.9539 43.7623L78.5539 48.0746L82.0809 54.016Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
